import script from "./consumer.vue?vue&type=script&setup=true&lang=ts"
export * from "./consumer.vue?vue&type=script&setup=true&lang=ts"

import "./consumer.vue?vue&type=style&index=0&id=0e319d71&scoped=true&lang=less"
import "./consumer.vue?vue&type=style&index=1&id=0e319d71&scoped=true&lang=less"

import exportComponent from "/Users/jizhengliang/Desktop/octopus/edu/educms-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e319d71"]])

export default __exports__